import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8393504a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "content" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { id: "header" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Detailed Statistics", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "expand" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.LonLat[0])
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _hoisted_5,
            _createElementVNode("h4", null, "LON " + _toDisplayString(_ctx.fmt(_ctx.LonLat[0]) + "E, LAT " + _ctx.fmt(_ctx.LonLat[1]) + "N"), 1)
          ]),
          _createElementVNode("table", null, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _hoisted_6,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Periods, (p) => {
                  return (_openBlock(), _createElementBlock("th", { key: p }, _toDisplayString(p), 1))
                }), 128))
              ])
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_ctx.Stats), (atype) => {
              return (_openBlock(), _createElementBlock("tr", { key: atype }, [
                _createElementVNode("td", null, [
                  _createElementVNode("b", null, _toDisplayString(atype), 1)
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_ctx.Stats[atype]), (v) => {
                  return (_openBlock(), _createElementBlock("td", { key: v }, _toDisplayString(_ctx.fmt(_ctx.Stats[atype][v])), 1))
                }), 128))
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}